import Vue from "vue";
import Cookies from "js-cookie";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "@/styles/index.scss"; // global css

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./icons"; // icon
import "./permission";

import * as filters from "./filters"; // global filters

import permission from "@/directive/permission/index.js"; // 权限判断指令

import Print from "@/utils/print"; // 打印

Vue.use(Print);

// 防止el-button重复点击
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
});

// import Print from './assets/print'
// Vue.use(Print);

Vue.use(Element, {
  size: Cookies.get("size") || "medium" // set element-ui default size
});

Vue.directive("permission", permission);

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
